<!--
  EditorSectionHeader.vue

  Page-level header for store-editor sub-pages, per the 2026-05-29
  campaign-editor design handoff. One per page: optional eyebrow tag
  (SETUP / CATALOG / OPERATIONS / STATUS), required title rendered as
  the section's h1, and an optional description below.

  Companion to EditorCard (card-level chrome). EditorSectionHeader sits
  at the top of each section page; EditorCard wraps each card inside.

  Adoption sweep is PR A3; this component ships standalone in A2.
-->
<template>
    <header
        class="editor-section-header"
        data-testid="editor-section-header"
    >
        <div
            v-if="eyebrow"
            class="editor-section-header__eyebrow"
            data-testid="editor-section-header-eyebrow"
        >
            {{ eyebrow }}
        </div>
        <h1
            class="editor-section-header__title"
            data-testid="editor-section-header-title"
        >
            {{ title }}
        </h1>
        <p
            v-if="description"
            class="editor-section-header__description"
            data-testid="editor-section-header-description"
        >
            {{ description }}
        </p>
    </header>
</template>

<script>
export default {
    name: "EditorSectionHeader",
    props: {
        eyebrow: { type: String, default: "" },
        title: { type: String, required: true },
        description: { type: String, default: "" },
    },
};
</script>

<style scoped>
.editor-section-header {
    margin-bottom: var(--tf-sp-5, 20px);
}
.editor-section-header__eyebrow {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: var(--tf-primary);
    margin-bottom: var(--tf-sp-1, 4px);
}
.editor-section-header__title {
    font-family: "Poppins", sans-serif;
    font-size: 22px;
    font-weight: 500;
    color: var(--tf-fg-1);
    margin: 0;
    line-height: 1.3;
}
.editor-section-header__description {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    color: var(--tf-fg-3);
    margin: var(--tf-sp-2, 8px) 0 0 0;
    line-height: 1.5;
    max-width: 720px;
}
</style>
